import { createContext } from 'react';

export const WalletNudgesContext = createContext<{
  showWalletSetAsideToast: (type?: 'toast' | 'modal') => void;
}>({ showWalletSetAsideToast: () => null });
